import { EnderecoPosRecadDTO } from 'app/components/pos-recadastramento/aba5-posrecad/enderecoPosRecad.dto';
import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ServidorRecad } from 'app/model/servidorRecad';
import { MatTableDataSource } from '@angular/material/table';
import { ThemePalette } from '@angular/material/core';
import { Observable, } from 'rxjs';
import { PosCampanhaServiceAba5 } from 'app/service/posCampanhaAba5/pos-campanha-aba5.service';
import { MatDialog } from '@angular/material/dialog';
import { ModalComponent } from "app/components/modal/modal.component";

type DadosTabela = {
  descricao: string;
  informacaoSrh: string;
  informacaoRecad: string;
  check: boolean;


  //  codTipoLogradouro: string;
  //  descLogradouro: string;
  //  numeroLogradouro: number;
  //  descBairro: string;
  //  descricaoMunicipioLogradouro: string;
  //  codMunicipioLogradouro: number;
  //  codUfLogradouro: string;
  //  codgUfRG: string;
  //  descComplementoLogradouro: string;

  // check: boolean;
}

@Component({
  selector: 'app-aba5-posrecad',
  templateUrl: './aba5-posrecad.component.html',
  styleUrls: ['./aba5-posrecad.component.sass']
})
export class Aba5PosrecadComponent implements OnInit {

  @Input() servidor: ServidorRecad;
  @Output() flExibirTab: EventEmitter<any> = new EventEmitter<any>();
  @Output() salvoOutput: EventEmitter<any> = new EventEmitter<any>();
  @Output() botoesDesabilitadosEnderecos: EventEmitter<any> = new EventEmitter<any>();
  @Input() btnDesativadoEnderecos: boolean;

  displayedColumns: string[] = ['descricao', 'antes', 'depois'];
  dataSource: MatTableDataSource<DadosTabela> = new MatTableDataSource<DadosTabela>([]);
  color: ThemePalette = 'primary';
  list: DadosTabela[] = [];
  isDisabledJustificativa: boolean = true
  enderecoPosRecad: EnderecoPosRecadDTO[];
  salvo: boolean = false;
  recadServidorId: number;
  justificativa: string = '';
  dadosEndereco: EnderecoPosRecadDTO;
  caracteresRestantes: number = 2000;

  constructor(private posCampanhaServiceAba5: PosCampanhaServiceAba5, private toasterService: ToastrService, public dialog: MatDialog) { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges) {
    this.dataSource.data = [];
    this.list = [];
    this.salvo = false;
    this.justificativa = "";
    this.findLotacao(this.servidor.id)
  }
  findLotacao(recadServidorId: number) {
    this.getObterEndereco(recadServidorId).subscribe(
      response => {
        this.dadosEndereco = response

        if (response) {
          this.dataSource.data = this.montarDadosTabela(response)

        } else {
          this.flExibirTab.emit(false);
        }
      },
      (error) => {
        console.error(error);
      }
    );
  }
  formatarCEP(cep: string): string {
    if (cep && cep.length === 8) {
      return cep.substring(0, 5) + '-' + cep.substring(5);
    } else if (cep && cep.length === 5) {
      return cep;
    }
    return cep; // Retorna o valor original se não tiver 5 ou 8 dígitos
  }

  visualizarArquivoEndereco() {
    this.getArquivoEndereco().subscribe(
      response => {
        const blobUrl = URL.createObjectURL(response);

        // Especifica as dimensões da nova janela (largura x altura)
        const newWindow = window.open(blobUrl, '_blank', 'width=800,height=800');

        // Verifica se a janela foi aberta com sucesso
        if (newWindow) {
          newWindow.focus();
        } else {
          this.toasterService.warning('Erro ao abrir a nova janela.', '', {
            timeOut: 1500
          });
        }
      },
      error => {
        this.toasterService.warning('Erro ao visualizar o arquivo.', '', {
          timeOut: 1500
        });
      }
    );
  }

  getArquivoEndereco(): Observable<any> {
    return this.posCampanhaServiceAba5.getArquivoEndereco(this.dadosEndereco.recadValidacaoEnderecoId);

  }

  private montarDadosTabela(resp: EnderecoPosRecadDTO): DadosTabela[] {
    this.list.push(
      { descricao: "CEP", informacaoSrh: resp.cepSrh, informacaoRecad: resp.cepRecad, check: true },
      { descricao: "Tipo Logradouro", informacaoSrh: resp.tipoLogradouroSrh, informacaoRecad: resp.tipoLogradouroRecad, check: true },
      { descricao: "Número", informacaoSrh: resp.numeLogradouroSrh, informacaoRecad: resp.numeLogradouroRecad, check: true },
      { descricao: "Logradouro", informacaoSrh: resp.descLogradouroSrh, informacaoRecad: resp.descLogradouroRecad, check: true },
      { descricao: "Bairro", informacaoSrh: resp.descBairroSrh, informacaoRecad: resp.descBairroRecad, check: true },
      { descricao: "Municipio", informacaoSrh: resp.municipioSrh, informacaoRecad: resp.municipioRecad, check: true },
      { descricao: "UF", informacaoSrh: resp.codgUfLogradouroSrh, informacaoRecad: resp.codgUfLogradouroRecad, check: true },
      { descricao: "Complemento", informacaoSrh: resp.descComplementoLogradouroSrh, informacaoRecad: resp.descComplementoLogradouroRecad, check: true },
    )
    return this.list;
  }

  private getObterEndereco(recadServidorId: number): Observable<EnderecoPosRecadDTO> {
    return this.posCampanhaServiceAba5.getObterEndereco(recadServidorId);
  }


  openDialog(): void {
    this.dialog.open(ModalComponent, {
      width: '450px',
      data: {
        header: 'Justificativa',
        descricao: 'Justifique o motivo de recusa:',
        labelOne: 'Cancelar',
        labelTwo: 'Salvar',
        flTextArea: true,
        action: (justificativa: string) => {
          this.justificativa = justificativa;
          this.salvar(3)
          this.botoesDesabilitadosEnderecos.emit(true);

        }
      }
    });
  }

  rejeitar(status) {
    this.isDisabledJustificativa = false
    this.openDialog();

    // if (this.justificativa == '') {
    //   this.toasterService.warning('Atenção: O campo justificativa é obrigatório.');
    //   return
    // }
    // else {
    //   this.salvar(status)
    // }
  }

  salvar(status) {
    /*
    status
    1- aceito
    2-pendente
    3- recusado
    4- sem alteracao
    * */
    this.botoesDesabilitadosEnderecos.emit(true);
    if (status == 1) {
      this.justificativa = ''
    }

    let body = {
      id: this.servidor.id,
      justificativa: this.justificativa,
      status: this.justificativa ? 3 : 1
    }
    this.posCampanhaServiceAba5.postDadosEndereco(body).subscribe(resp => {
      this.toasterService.success("Dados salvos com sucesso");
      this.salvo = true;
      this.salvoOutput.emit(true);
    });
  }
}
